var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimplifiedWorkflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4993 50.6665C41.8588 50.6665 45.0806 49.332 47.456 46.9565C49.8315 44.5811 51.166 41.3592 51.166 37.9998C51.166 34.6404 49.8315 31.4186 47.456 29.0432C45.0806 26.6677 41.8588 25.3332 38.4993 25.3332C35.1399 25.3332 31.9181 26.6677 29.5427 29.0432C27.1672 31.4186 25.8327 34.6404 25.8327 37.9998C25.8327 41.3592 27.1672 44.5811 29.5427 46.9565C31.9181 49.332 35.1399 50.6665 38.4993 50.6665ZM38.4993 22.1665C40.5786 22.1665 42.6375 22.576 44.5585 23.3717C46.4795 24.1674 48.2249 25.3337 49.6952 26.804C51.1655 28.2742 52.3317 30.0197 53.1274 31.9407C53.9231 33.8617 54.3327 35.9206 54.3327 37.9998C54.3327 42.1991 52.6645 46.2264 49.6952 49.1957C46.7259 52.165 42.6986 53.8332 38.4993 53.8332C29.7435 53.8332 22.666 46.7082 22.666 37.9998C22.666 33.8006 24.3342 29.7733 27.3035 26.804C30.2728 23.8347 34.3001 22.1665 38.4993 22.1665ZM39.291 30.0832V38.3957L46.416 42.6232L45.2285 44.5707L36.916 39.5832V30.0832H39.291Z",
    fill: "url(#paint0_linear_2785_10360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2785_10360",
    x1: 22.666,
    y1: 37.9998,
    x2: 54.3327,
    y2: 37.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplifiedWorkflow);
export default __webpack_public_path__ + "static/media/Simplified Workflow.c8eb05e018c1452ba8972f9fa765df7c.svg";
export { ForwardRef as ReactComponent };